/** @format */

import { useMemo } from 'react';
import Skeleton from '@mui/material/Skeleton';

const skeletonStyle = { backgroundColor: 'rgba(0, 0, 0, 0.1)' };
const CARD_COUNT = 2;
const CONTENT_LINE_COUNT = 3;

type LegalPageSkeletonProps = {
  label: string;
};

const CardSkeleton = () => (
  <article className="card-list__card">
    <div className="card-list__body">
      <Skeleton
        className="legal-page-skeleton__media"
        variant="rectangular"
        width="100%"
        height={205}
        style={skeletonStyle}
      />
      <div className="card-list__copy">
        <Skeleton variant="text" width="75%" height={26} style={skeletonStyle} />
        <Skeleton variant="text" width="42%" height={20} style={skeletonStyle} />
        <Skeleton variant="text" width="100%" height={22} style={skeletonStyle} />
        <Skeleton variant="text" width="82%" height={22} style={skeletonStyle} />
      </div>
    </div>
    <div className="card-list__actions">
      <Skeleton
        className="legal-page-skeleton__button"
        variant="rectangular"
        width={88}
        height={32}
        style={skeletonStyle}
      />
      <Skeleton
        className="legal-page-skeleton__button"
        variant="rectangular"
        width={148}
        height={32}
        style={skeletonStyle}
      />
    </div>
  </article>
);

export const LegalPageSkeleton = ({ label }: LegalPageSkeletonProps) => {
  const contentLineWidths = useMemo(
    () => Array.from({ length: CONTENT_LINE_COUNT }, () => `${Math.floor(45 + Math.random() * 55)}%`),
    []
  );

  return (
    <div role="status" aria-live="polite" aria-busy="true" aria-label={label}>
      <div className="breadcrumbWrapper container legal-page-skeleton__breadcrumb" aria-hidden="true">
        <Skeleton variant="circular" width={20} height={20} style={skeletonStyle} />
        <Skeleton variant="text" width={180} height={24} style={skeletonStyle} />
      </div>
      <div className="content-container container card-list-page legal-page-skeleton" aria-hidden="true">
        <div className="archive-page-title-box">
          <Skeleton
            className="legal-page-skeleton__title"
            variant="rectangular"
            width="70%"
            height={64}
            style={skeletonStyle}
          />
        </div>
        <div className="card-list">
          {Array.from({ length: CARD_COUNT }, (_, index) => (
            <CardSkeleton key={index} />
          ))}
        </div>
        <div className="legal-page-skeleton__lines">
          {contentLineWidths.map((width, index) => (
            <Skeleton
              key={index}
              className="legal-page-skeleton__line"
              variant="text"
              width={width}
              height={22}
              style={skeletonStyle}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
